<template>
  <screen-card title="Activités">
    <template v-for="(widget, index) in first3widgets">
      <WidgetPrimary :key="index" :title="widget.title">
        <div :key="index" class="widget-content">
          <div v-if="widget.type === 'ANNOUNCEMENT'" class="btn-content">
            <h5 class="title">{{ widget.content }}</h5>
          </div>
          <b-button v-else class="btn-content" variant="transparent">
            <h5 class="title">{{ widget.content }}</h5>
          </b-button>
        </div>
      </WidgetPrimary>
    </template>
  </screen-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator"
import { ScreenWidgetList } from "../../queries/screen/graphql"
import WidgetPrimary from "@/components/widgets/widget-primary.vue"

@Component({
  components: {
    WidgetPrimary,
    "screen-card": () => import("./screen-card.vue"),
    "screen-team-item": () => import("./screen-team-item.vue"),
  },
})
export default class ScreenCardTeam extends Vue {
  @Prop({ type: Object, required: true }) readonly widgets!: ScreenWidgetList

  get first3widgets() {
    return this.widgets.widgets.slice(0, 3)
  }
}
</script>
<style scoped lang="scss">
@import "../../style/variables";

.card-team {
  background-position: bottom right;
  background-size: 33.46%;
  background-repeat: no-repeat;

  .content {
    width: 75%;
    font-size: 275%;
    color: $secondary;
    display: inline-block;
  }

  .divider {
    width: 22.9%;
    margin: 8% auto;
    display: block;
  }

  .info-unavailable {
    margin: 36% 0;
    text-align: center;
    font-size: 250%;
    font-weight: 600;
    font-family: "Lobster", sans-serif;
    color: $secondary;
  }
}

.widget-content {
  width: 100%;
  padding: 15px 20px 24px 20px;

  .btn-content {
    width: 100%;
    padding: 0;
    border-radius: 8px;
  }

  .title {
    padding: 10px;
    border-radius: 8px;
  }
}
</style>
